import { render, staticRenderFns } from "./AlertaPedidosSync.vue?vue&type=template&id=15078086&"
import script from "./AlertaPedidosSync.vue?vue&type=script&lang=js&"
export * from "./AlertaPedidosSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports